import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StorageLoader } from '@utils/storageLoader';
import { UserService } from '../global/user.service';

@Injectable({
  providedIn: 'root'
})
export class SharedEventService {
  private taskEventSource = new Subject<any>();
  taskEvent$ = this.taskEventSource.asObservable();

  constructor(
    private storageLoader: StorageLoader,
    private userService: UserService
  ) { }

  async emitEvent(type: string, value: any = false) {
    try {
      if (type == 'reload_user' && value == true) {
        const response = await this.userService.refresh();

        if (response.system_info) {
          await this.storageLoader.setSystemInfo(response.system_info);
        }

        if (response.system_menu) {
          await this.storageLoader.setSystemMenu(response.system_menu);
        }

        if (response.user) {
          await this.storageLoader.setUser(response.user);
        }
      }

      this.taskEventSource.next({
        type: type,
        value: value
      });
    } catch (err) {
      throw err;
    }
  }
}
